import { CultureInfo } from '../culture-info.model';
import { CultureInfoAr } from './ar';

/**
 * @ignore
 */
export const CultureInfoArSO: CultureInfo = {
  name: 'ar-SO',
  displayName: 'العربية (الصومال)',
  iso3LanguageCode: 'ara',
  iso2LanguageCode: 'ar',
  ietfLanguageTag: 'ar-SO',
  parent: CultureInfoAr
};
